import { Directive, HostListener, Input } from '@angular/core';

import { AnalyticsBase } from './analytics-base';
import { AppState } from 'src/app/app.state';
import { LoggerService } from '../logger/logger.service';
import { Store } from '@ngrx/store';

@Directive({
	selector: '[ahpAnalyticsClick]',
})
export class AnalyticsClickDirective extends AnalyticsBase {
	/**
	 * @param store The global store
	 */
	constructor(store: Store<AppState>, logger: LoggerService) {
		super(store, logger, 'AnalyticsClickDirective');
	}

	/**
	 * Handles parsing the string to set event details.
	 * @example 'action|category|label|value' should be the string you set the directive to. Action, category and label are required.
	 */
	@Input('ahpAnalyticsClick')
	set ahpAnalytics(eventData: string) {
		this.setAnalyticsData(eventData);
	}

	/**
	 * Handles the click event and sending the event to GA.
	 */
	@HostListener('click')
	onClick() {
		this.sendEvent();
	}
}
